import React from 'react';

export function AdminCoursesTab({ courses }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Course Management
        </h1>
      </div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map(course => (
          <div key={course.id} className="bg-[#141417] border border-[#27272A] rounded-md p-4" data-testid={`course-${course.id}`}>
            <img src={course.image_url} alt={course.title} className="w-full h-32 object-cover rounded-sm mb-4" />
            <h3 className="text-white font-medium">{course.title}</h3>
            <p className="text-[#007AFF] font-mono">${course.price}</p>
            <p className="text-[#71717A] text-sm mt-2">{course.lessons?.length || 0} lessons</p>
          </div>
        ))}
      </div>
    </div>
  );
}
